<template>
    <b-modal id="complaint_review" ref="complaint_review" @hidden="resetModal" no-close-on-backdrop>

        <template v-slot:modal-title>
            <div>
                Complaint Review
            </div>
        </template>

        <div class="mb-4">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ducimus, neque.
        </div>

        <b-form>
            <b-row class="">
                <b-colxx md="12">
                    <b-form-group label="Assigned To " class="has-float-label">
                        <template v-slot:label>
                            <span>Reviewed By <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" :value="authUserInfo.attributes.name" disabled/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="6">
                    <b-form-group label="Review Date" class="has-float-label">
                        <template v-slot:label>
                            <span>Review Date <sup><code>*</code></sup></span>
                        </template>

                        <v-date-picker
                            popover-visibility="focus" mode="single"
                            v-model="datepicker.date"
                            @input="'date' in errors ? delete errors.date : ''"
                            :input-props="{ class:'form-control' + ('date' in errors ? ' border-danger' : ''), placeholder: 'MM-DD-YYYY' }"/>

                        <b-form-invalid-feedback :state="!'date' in errors"
                                                 v-text="'date' in errors ? errors.date[0] : ''"/>
                    </b-form-group>
                </b-colxx>

                <b-colxx md="6">
                    <b-form-group label="Hasa Respond Date" class="has-float-label">
                        <v-date-picker
                            popover-visibility="focus" mode="single"
                            v-model="datepicker.hasa_respond_date"
                            @input="'hasa_respond_date' in errors ? delete errors.hasa_respond_date : ''"
                            :input-props="{ class:'form-control' + ('hasa_respond_date' in errors ? ' border-danger' : ''), placeholder: 'MM-DD-YYYY' }"/>

                        <b-form-invalid-feedback :state="!'hasa_respond_date' in errors"
                                                 v-text="'hasa_respond_date' in errors ? errors.hasa_respond_date[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <vue-dropzone ref="fileDropZone" id="dropzone"
                                  @vdropzone-error="attachmentError"
                                  :destroy-dropzone="false" :options="dropzoneOptions"/>
                </b-colxx>
            </b-row>
        </b-form>

        <template slot="modal-footer">
            <b-button size="sm" variant="secondary" @click="hideModal('complaint_review')" v-text="'Cancel'"/>

            <state-button size="sm" variant="primary" :click="submitComplaintReview">Submit</state-button>
        </template>
    </b-modal>
</template>

<script>
import StateButton from "../../../../../components/Common/StateButton";
import {mapGetters} from "vuex";
import VueDropzone from 'vue2-dropzone';
import moment from "moment";

export default {
    name: "ReviewFormModal",

    components: {
        StateButton,
        VueDropzone
    },

    props: [
        'complaint'
    ],

    mounted() {
        this.getAuthUser()
    },

    data() {
        return {
            datepicker: {
                date: null,
                hasa_respond_date: null,
            },
            dropzoneOptions: {
                url: 'url',
                thumbnailHeight: 160,
                acceptedFiles: '.jpg,.jpeg,.png,.pdf',
                maxFilesize: 10,
                previewTemplate: this.dropzoneTemplate(),
                headers: {
                    'Authorization': 'Bearer ' + this.$store.getters.accessToken
                },
                dictDefaultMessage: 'Drop or Click here to upload files.<br>Max file size 10MB.<br>Accepted file types: JPG, JPEG, PNG, PDF.',
                autoProcessQueue: false
            },
        }
    },

    computed: {
        ...mapGetters({
            authUserInfo: "authUserInfo",
            form: 'getComplaintReviewForm',
            errors: 'getComplaintErrors',
        }),
    },

    watch: {
        'datepicker.date'(date) {
            if (moment(date).format('YYYY-MM-DD') === 'Invalid date') return this.form.date = null;
            this.form.date = moment(date).format('YYYY-MM-DD');
        },
        'datepicker.hasa_respond_date'(date) {
            if (moment(date).format('YYYY-MM-DD') === 'Invalid date') return this.form.hasa_respond_date = null;
            this.form.hasa_respond_date = moment(date).format('YYYY-MM-DD');
        },
    },

    methods: {
        async getAuthUser() {
            await this.$store.dispatch('retrieveAuthUserInfo');
        },

        submitComplaintReview() {
            return new Promise((success, fail) => {
                this.$store.dispatch('submitComplaintReview', this.form)
                    .then(response => {
                        this.uploadFiles(response.data);
                    })
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('updated');

                            this.$notify('success filled', 'Success!', 'Added complaint review!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('complaint_review');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },

        resetModal() {
            this.$store.commit('setComplaintReviewForm');

            this.datepicker =  {
                date: null,
            };
        },

        hideModal(refname) {
            this.$refs[refname].hide();
        },

        attachmentError(file, message, xhr) {
            this.$refs.fileDropZone.removeFile(file);
            this.$notify('error filled', 'Error!', file.name + " could not be added!", {
                duration: 6000,
                permanent: false
            });
        },

        uploadFiles(review) {
            let url = '/api/hms/compliances/complaints/' + this.complaint.complaint_id + '/review/attachments';

            this.$refs.fileDropZone.setOption('url', url);

            this.$refs.fileDropZone.processQueue(review);
        },

        dropzoneTemplate() {
            return `<div class="dz-preview dz-file-preview mb-3">
                  <div class="d-flex flex-row "> <div class="p-0 w-30 position-relative">
                      <div class="dz-error-mark"><span><i></i>  </span></div>
                      <div class="dz-success-mark"><span><i></i></span></div>
                      <div class="preview-container">
                        <img data-dz-thumbnail class="img-thumbnail border-0" />
                        <i class="simple-icon-doc preview-icon"></i>
                      </div>
                  </div>
                  <div class="pl-3 pt-2 pr-2 pb-1 w-70 dz-details position-relative">
                    <div> <span data-dz-name /> </div>
                    <div class="text-primary text-extra-small" data-dz-size /> </div>
                    <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
                    <div class="dz-error-message"><span data-dz-errormessage></span></div>
                  </div>
                  <a href="#" class="remove" data-dz-remove> <i class="glyph-icon simple-icon-trash"></i> </a>
                </div>`
        },
    },
}
</script>

<style scoped>

</style>
